module.exports = __webpack_public_path__ + "img/1404849407.f5b927c6.jpg";